var _rect, _rect2, _g, _g2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLightTheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 57,
    viewBox: "0 0 128 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.99805,
    y: 4.84277,
    width: 122.611,
    height: 47.1579,
    rx: 23.5789,
    fill: "#A2D1FD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3118_62264",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 124,
    height: 49
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.99805,
    y: 4.84277,
    width: 122.611,
    height: 47.1579,
    rx: 23.5789,
    fill: "#E0FDFF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3118_62264)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_3118_62264)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.99805,
    y: 4.84277,
    width: 122.611,
    height: 47.1579,
    rx: 23.5789,
    fill: "#A2D1FD"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 71.9237,
    cy: 47.5324,
    r: 9.90316,
    transform: "rotate(-3.84411 71.9237 47.5324)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.66,
    cy: 40.9386,
    r: 9.90316,
    transform: "rotate(-3.84411 85.66 40.9386)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.4198,
    cy: 52.2306,
    r: 9.90316,
    transform: "rotate(-3.84411 86.4198 52.2306)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.0839,
    cy: 42.9386,
    r: 9.90316,
    transform: "rotate(-3.84411 98.0839 42.9386)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.42,
    cy: 52.0334,
    r: 9.90316,
    transform: "rotate(-3.84411 103.42 52.0334)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.33,
    cy: 44.7502,
    r: 9.90316,
    transform: "rotate(-3.84411 113.33 44.7502)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.5233,
    cy: 56.423,
    r: 9.90316,
    transform: "rotate(-3.84411 22.5233 56.423)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.2596,
    cy: 49.8293,
    r: 9.90316,
    transform: "rotate(-3.84411 36.2596 49.8293)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.0194,
    cy: 61.1212,
    r: 9.90316,
    transform: "rotate(-3.84411 37.0194 61.1212)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.6835,
    cy: 51.8293,
    r: 9.90316,
    transform: "rotate(-3.84411 48.6835 51.8293)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.0194,
    cy: 60.924,
    r: 9.90316,
    transform: "rotate(-3.84411 54.0194 60.924)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.9296,
    cy: 53.6418,
    r: 9.90316,
    transform: "rotate(-3.84411 63.9296 53.6418)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 80.5097,
    cy: 34.7287,
    r: 9.90316,
    transform: "rotate(-3.84411 80.5097 34.7287)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.246,
    cy: 28.1349,
    r: 9.90316,
    transform: "rotate(-3.84411 94.246 28.1349)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.0057,
    cy: 39.4269,
    r: 9.90316,
    transform: "rotate(-3.84411 95.0057 39.4269)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.67,
    cy: 30.1349,
    r: 9.90316,
    transform: "rotate(-3.84411 106.67 30.1349)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.006,
    cy: 39.2296,
    r: 9.90316,
    transform: "rotate(-3.84411 112.006 39.2296)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.916,
    cy: 31.9464,
    r: 9.90316,
    transform: "rotate(-3.84411 121.916 31.9464)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 38.6743,
    cy: 50.4932,
    r: 9.90316,
    transform: "rotate(-4.59401 38.6743 50.4932)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.3208,
    cy: 43.7207,
    r: 9.90316,
    transform: "rotate(-4.59401 52.3208 43.7207)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.229,
    cy: 55.001,
    r: 9.90316,
    transform: "rotate(-4.59401 53.229 55.001)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.7719,
    cy: 45.5586,
    r: 9.90316,
    transform: "rotate(-4.59401 64.7719 45.5586)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.2251,
    cy: 54.5821,
    r: 9.90316,
    transform: "rotate(-4.59401 70.2251 54.5821)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.0395,
    cy: 47.1699,
    r: 9.90316,
    transform: "rotate(-4.59401 80.0395 47.1699)",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ddii_3118_62264)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.9246,
    height: 38.9246,
    rx: 19.4623,
    transform: "matrix(-1 3.99602e-09 3.99602e-09 1 47.7207 9.01367)",
    fill: "#FFC187",
    fillOpacity: 0.96
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3118_62264",
    x: 4.99805,
    y: 4.84277,
    width: 122.61,
    height: 52.8172,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.65895
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.24421
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.445833 0 0 0 0 0.734 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3118_62264"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ddii_3118_62264",
    x: 0.307476,
    y: 0.525249,
    width: 55.9016,
    height: 55.9016,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.24421
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.756863 0 0 0 0 0.529412 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3118_62264"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.82947,
    dy: 4.71579
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88632
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.717122 0 0 0 0 0.717122 0 0 0 0 0.717122 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3118_62264",
    result: "effect2_dropShadow_3118_62264"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3118_62264",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.88632
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88632
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.816106 0 0 0 0 0.645833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_3118_62264"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.88632
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88632
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.631795 0 0 0 0 0.2875 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_3118_62264",
    result: "effect4_innerShadow_3118_62264"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightTheme);
export default __webpack_public_path__ + "static/media/light-theme.37743d68.svg";
export { ForwardRef as ReactComponent };